import {
    useEffect,
    useState,
} from "react";

import souqMadarMark from "@/assets/brand/souq-madar-mark.png";
import { useLang } from "@/contexts/LangContext";
import { fileUrl } from "@/lib/api";


export default function ProductImage({
    src,
    alt = "",
    imageClassName = "",
    showLabel = true,
}) {
    const {
        lang,
    } = useLang();

    const resolvedSrc = fileUrl(src);

    const [failed, setFailed] = useState(
        !resolvedSrc
    );


    useEffect(() => {
        setFailed(
            !resolvedSrc
        );
    }, [
        resolvedSrc,
    ]);


    if (failed) {
        const label = (
            lang === "ar"
                ? "\u0644\u0627 \u062a\u0648\u062c\u062f \u0635\u0648\u0631\u0629 \u0644\u0644\u0645\u0646\u062a\u062c"
                : "No product image"
        );

        if (!showLabel) {
            return (
                <div
                    className="w-full h-full bg-surface grid place-items-center"
                    role="img"
                    aria-label={label}
                >
                    <img
                        src={souqMadarMark}
                        alt=""
                        aria-hidden="true"
                        className="w-[68%] h-[68%] object-contain opacity-90"
                    />
                </div>
            );
        }

        return (
            <div
                className="w-full h-full bg-surface grid place-items-center"
                role="img"
                aria-label={label}
            >
                <div className="flex flex-col items-center justify-center gap-3 px-4 text-center">
                    <img
                        src={souqMadarMark}
                        alt=""
                        aria-hidden="true"
                        className="w-16 h-16 rounded-2xl object-contain opacity-90"
                    />

                    <span className="text-xs md:text-sm font-bold text-muted-foreground">
                        {label}
                    </span>
                </div>
            </div>
        );
    }


    return (
        <img
            src={resolvedSrc}
            alt={alt}
            className={imageClassName}
            loading="lazy"
            onError={() => {
                setFailed(true);
            }}
        />
    );
}
